import { render } from "./IconUnpairing.vue?vue&type=template&id=0b679dac"
import script from "./IconUnpairing.vue?vue&type=script&lang=ts"
export * from "./IconUnpairing.vue?vue&type=script&lang=ts"
script.render = render

export default script